/**
 * @file shallowMerge
 * @author yuzong(yuzong@tencent.com)
 */
import { assign } from './assign';
export function shallowMerge(source1, source2) {
  var target = {};
  assign(target, source1, source2);
  return target;
}